import { useEffect, useState } from 'react';
import { generateSimulatedOrderBook } from '../utils/simulatedOrderBook';

export function useSimulatedOrderBook(symbol: string, referencePrice: number, levels: number) {
  const [state, setState] = useState(() => ({
    symbol, referencePrice, book: generateSimulatedOrderBook(referencePrice, levels),
  }));

  useEffect(() => {
    const update = () => setState({ symbol, referencePrice, book: generateSimulatedOrderBook(referencePrice, levels) });
    update();
    if (!Number.isFinite(referencePrice) || referencePrice <= 0) return;
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [symbol, referencePrice, levels]);

  // A pair/quote change must never briefly display levels from the previous pair.
  return state.symbol === symbol && state.referencePrice === referencePrice
    ? state.book : { asks: [], bids: [], lastUpdateId: 0 };
}
